import { css } from "lit";
// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[0].use[1]!../../components/button/common.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[0].use[1]!../../components/visually-hidden/index.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  font: 400 var(--base-font-size) var(--font-body);
}

.observatory-form__input-group {
  display: flex;
  height: 3rem;
}

.observatory-form__input-group :focus-visible {
    outline: 1px solid var(--observatory-accent);
    outline-width: 1px;
    outline-offset: -1px;
  }

.observatory-form__input-group ::placeholder {
    color: var(--color-text-secondary);
    opacity: 0.8;
  }

.observatory-form__input-group .observatory-form__input {
    flex-grow: 1;

    width: 100%;

    padding: 0 0.75rem;

    font: inherit;

    background-color: var(--color-background-secondary);
    border: 1px solid var(--color-border-secondary);
    border-top-left-radius: var(--border-radius);
    border-bottom-left-radius: var(--border-radius);
  }

:is(.observatory-form__input-group .observatory-form__input)::placeholder {
      overflow-x: hidden;
      text-overflow: ellipsis;
    }

.observatory-form__input-group .observatory-form__submit {
    height: unset;

    padding: 0 2rem;

    font: var(--type-emphasis-m);
    font-size: 1rem;

    /* color: var(--button-color--default); */

    /* appearance: none;
    cursor: pointer; */

    /* background: var(--button-bg--default); */
    border: none;
    border-radius: 0 var(--border-radius) var(--border-radius) 0;
    border-top-right-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
  }

.error {
  margin-top: 0.5rem;
  color: var(--form-invalid-color);
}

.error::before {
    display: inline-block;

    width: 1.5em;
    height: 1.15rem;

    margin-right: 0.5rem;
    margin-bottom: 0.25rem;

    vertical-align: middle;

    content: "";

    background-color: var(--form-invalid-color);

    -webkit-mask-image: var(--alert-circle-img);

            mask-image: var(--alert-circle-img);
    -webkit-mask-repeat: no-repeat;
            mask-repeat: no-repeat;
    -webkit-mask-position: center;
            mask-position: center;
  }
`, "",{"version":3,"sources":["webpack://./observatory/landing/form.css"],"names":[],"mappings":"AAGA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,YAAY;AAoDd;;AAlDE;IACE,4CAA4C;IAC5C,kBAAkB;IAClB,oBAAoB;EACtB;;AAEA;IACE,kCAAkC;IAClC,YAAY;EACd;;AAEA;IACE,YAAY;;IAEZ,WAAW;;IAEX,kBAAkB;;IAElB,aAAa;;IAEb,mDAAmD;IACnD,+CAA+C;IAC/C,4CAA4C;IAC5C,+CAA+C;EAMjD;;AAJE;MACE,kBAAkB;MAClB,uBAAuB;IACzB;;AAGF;IACE,aAAa;;IAEb,eAAe;;IAEf,4BAA4B;IAC5B,eAAe;;IAEf,yCAAyC;;IAEzC;sBACkB;;IAElB,2CAA2C;IAC3C,YAAY;IACZ,4DAA4D;IAC5D,6CAA6C;IAC7C,gDAAgD;EAClD;;AAGF;EACE,kBAAkB;EAClB,gCAAgC;AAqBlC;;AAnBE;IACE,qBAAqB;;IAErB,YAAY;IACZ,eAAe;;IAEf,oBAAoB;IACpB,sBAAsB;;IAEtB,sBAAsB;;IAEtB,WAAW;;IAEX,2CAA2C;;IAE3C,2CAAmC;;YAAnC,mCAAmC;IACnC,8BAAsB;YAAtB,sBAAsB;IACtB,6BAAqB;YAArB,qBAAqB;EACvB","sourcesContent":["@import url(\"../../components/button/common.css\");\n@import url(\"../../components/visually-hidden/index.css\");\n\n:host {\n  font: 400 var(--base-font-size) var(--font-body);\n}\n\n.observatory-form__input-group {\n  display: flex;\n  height: 3rem;\n\n  :focus-visible {\n    outline: 1px solid var(--observatory-accent);\n    outline-width: 1px;\n    outline-offset: -1px;\n  }\n\n  ::placeholder {\n    color: var(--color-text-secondary);\n    opacity: 0.8;\n  }\n\n  .observatory-form__input {\n    flex-grow: 1;\n\n    width: 100%;\n\n    padding: 0 0.75rem;\n\n    font: inherit;\n\n    background-color: var(--color-background-secondary);\n    border: 1px solid var(--color-border-secondary);\n    border-top-left-radius: var(--border-radius);\n    border-bottom-left-radius: var(--border-radius);\n\n    &::placeholder {\n      overflow-x: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .observatory-form__submit {\n    height: unset;\n\n    padding: 0 2rem;\n\n    font: var(--type-emphasis-m);\n    font-size: 1rem;\n\n    /* color: var(--button-color--default); */\n\n    /* appearance: none;\n    cursor: pointer; */\n\n    /* background: var(--button-bg--default); */\n    border: none;\n    border-radius: 0 var(--border-radius) var(--border-radius) 0;\n    border-top-right-radius: var(--border-radius);\n    border-bottom-right-radius: var(--border-radius);\n  }\n}\n\n.error {\n  margin-top: 0.5rem;\n  color: var(--form-invalid-color);\n\n  &::before {\n    display: inline-block;\n\n    width: 1.5em;\n    height: 1.15rem;\n\n    margin-right: 0.5rem;\n    margin-bottom: 0.25rem;\n\n    vertical-align: middle;\n\n    content: \"\";\n\n    background-color: var(--form-invalid-color);\n\n    mask-image: var(--alert-circle-img);\n    mask-repeat: no-repeat;\n    mask-position: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default css([___CSS_LOADER_EXPORT___.toString()]);
